// Fonds de carte utilisables hors-ligne : tuiles Web Mercator servies avec CORS (vérifiées les 2026-10-28 et 29, tâche 1.12).
// Module sans DOM ni Leaflet : il est aussi importé par le service worker
export const OFFLINE_TILES_CACHE = 'offline-tiles';

// Ordre de priorité : la bascule automatique prend la première source proposée. area : nom de la zone de projects/mapAreas
// (MunicipalityProperties.IsMapArea) dans laquelle la source est proposée
export const OFFLINE_BASE_LAYERS = [
    {
        id: 'be-wal-ortho', label: 'Orthophoto WalOnMap', area: 'Wallonie',
        // Export ArcGIS (le cache du SPW n'existe qu'en Lambert 72) : tuile calculée à la demande, bbox en dernier pour un préfixe propre
        url: 'https://geoservices.wallonie.be/arcgis/rest/services/IMAGERIE/ORTHO_LAST/MapServer/export?f=image&format=jpg&size=256,256&bboxSR=3857&imageSR=3857&bbox={bbox}',
        maxNativeZoom: 19, attribution: '© SPW (WalOnMap)'
    },
    {
        id: 'be-cartoweb-topo', label: 'Plan IGN Belgique', area: 'Belgique',
        url: 'https://cartoweb.wmts.ngi.be/1.0.0/topo/default/3857/{z}/{y}/{x}.png', maxNativeZoom: 17, attribution: '© IGN Belgique (CartoWeb.be)'
    },
    {
        id: 'fr-ign-ortho', label: 'Orthophoto IGN France', area: 'France',
        url: 'https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&STYLE=normal&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=image/jpeg',
        maxNativeZoom: 19, attribution: '© IGN Géoplateforme'
    }
];

// Début des URL de tuiles (jusqu'au premier paramètre variable) : seules ces requêtes vont dans le cache des tuiles
export const OFFLINE_TILE_PREFIXES = OFFLINE_BASE_LAYERS.map(layer => layer.url.slice(0, layer.url.indexOf('{')));

const EARTH_HALF = Math.PI * 6378137;

// URL d'une tuile ; bbox Web Mercator arrondie au centimètre, pour une URL identique au préchargement et à l'affichage
export const getOfflineTileUrl = (layer, { x, y, z }) => {
    const size = 2 * EARTH_HALF / 2 ** z;
    const bbox = [x * size - EARTH_HALF, EARTH_HALF - (y + 1) * size, (x + 1) * size - EARTH_HALF, EARTH_HALF - y * size].map(value => value.toFixed(2)).join(',');
    return layer.url.replace('{bbox}', bbox).replace('{x}', x).replace('{y}', y).replace('{z}', z);
};

const toTile = (lat, lng, zoom) => {
    const n = 2 ** zoom, latRad = lat * Math.PI / 180;
    return [Math.floor((lng + 180) / 360 * n), Math.floor((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2 * n)];
};

// Tuiles couvrant une emprise, du zoom le plus fort au plus faible : un niveau qui dépasse le budget n'est pas pris, ni les
// suivants (une grande emprise perd ses zooms faibles, jamais une partie de la zone)
export const getTilesForBounds = ({ west, south, east, north }, minZoom, maxZoom, budget) => {
    const tiles = [];
    for (let z = maxZoom; z >= minZoom; z--) {
        const [x1, y1] = toTile(north, west, z), [x2, y2] = toTile(south, east, z);
        if (tiles.length + (x2 - x1 + 1) * (y2 - y1 + 1) > budget) break;
        for (let x = x1; x <= x2; x++) for (let y = y1; y <= y2; y++) tiles.push({ x, y, z });
    }
    return tiles;
};
